import { Component, OnInit } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams } from '@ionic/angular';
import { StoreTypeForUserDto, StoreTypeService } from 'src/app/generate-client';

@Component({
  selector: 'app-store-types',
  templateUrl: './store-types.component.html',
  styleUrls: ['./store-types.component.scss'],
})

export class StoreTypesComponent implements OnInit {

  cdCity: number;
  storeTypes: Array<StoreTypeForUserDto>;
  loading: HTMLIonLoadingElement

  constructor(
    private modalController: ModalController,
    private _storeTypeService: StoreTypeService,
    private _navParam: NavParams,
    private _navController: NavController,
    private _loadingController: LoadingController
  ) { }

  async ngOnInit() {

    this.loading = await this._loadingController.create({
      message: "Cargando"
    })

    this.loading.present();

    this.cdCity = this._navParam.get('cdCity');
    this.GetStoreTypes();
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  public async goTo(page: string) {
    this.dismiss();
    this._navController.navigateForward(page);
  }

  private async GetStoreTypes() {
    this._storeTypeService.apiStoreTypeStoreTypesInCityGet(this.cdCity).subscribe(x => {
      this.storeTypes = x;
      this.loading.dismiss();
    });
  }
}
